import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import VehicleServiceService from "../services/vehicleServiceService";
import VehicleTypeService from "../services/VehicleTypeService";
import VehicleRegistrationService from "../services/vehicleRegistrationService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import MessageDialog from "../components/MessageDialog";

export default function AddVehicleService() {
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error");
  // const [isError, setIsError] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });


  useEffect(() => {
    if (id) {
      setIsEdit(true);
      setEditLoading(true);
    }
    loadInitialData();
  }, [id]);


  const loadInitialData = async () => {
    try {
      const res = await VehicleTypeService.getActiveVehicleTypes();
      setVehicleTypes(res.data || []);

      if (id) {
        setIsEdit(true);
        await fetchServiceRecordById(id);
      } else {
        reset({ status: "Active" });
      }
    } catch (error) {
      console.error("Initial load failed", error);
    }
  };


  useEffect(() => {
    if (!isEdit) {
      const today = new Date().toISOString().split("T")[0];
      setValue("serviceDate", today);
    }
  }, [isEdit, setValue]);



  const fetchServiceRecordById = async (serviceId) => {
    try {
      setLoading(true);
      setEditLoading(true);

      const res = await VehicleServiceService.getById(serviceId);

      if (!res || res.status !== true || !res.data) {
        setMessage("Failed to load Vehicle Service");
        setMsgType("error");
        return;
      }

      const record = res.data;


      if (record.vehicleTypeId) {
        const vehicleRes = await VehicleRegistrationService.getByVehicleTypeId(
          record.vehicleTypeId,
          StorageService.activeCompany().companyId
        );

        if (vehicleRes?.status && Array.isArray(vehicleRes.data)) {
          setVehicles(vehicleRes.data);
        }
      }

      // Fix Dates
      record.serviceDate = record.serviceDate
        ? new Date(record.serviceDate).toISOString().split("T")[0]
        : "";
      record.nextServiceDate = record.nextServiceDate
        ? new Date(record.nextServiceDate).toISOString().split("T")[0]
        : "";

      reset({
        id: record.id,
        vehicleTypeId: String(record.vehicleTypeId),
        vehicleId: String(record.vehicleId),
        serviceDate: record.serviceDate,
        nextServiceDate: record.nextServiceDate,
        serviceKMS: record.serviceKMS,
        nextServiceKMS: record.nextServiceKMS,
        status: record.status,
      });
    } catch (error) {
      console.error("Fetch by ID failed", error);
      setMessage("Error loading Vehicle Service details");
      setMsgType("error");
    } finally {
      setLoading(false);
      setEditLoading(false);
    }
  };


  const fetchVehicles = async (vehicleTypeId) => {
    if (!vehicleTypeId) return;

    try {
      const company = StorageService.activeCompany();
      const companyId = company?.companyId;

      const res = await VehicleRegistrationService.getByVehicleTypeId(
        vehicleTypeId,
        companyId
      );

      const data = res?.data || res?.data?.data || res || [];
      setVehicles(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Vehicle fetch error:", error);
      setVehicles([]);
    }
  };


  const onSubmit = async (data) => {
    try {
      setLoading(true);

      // const serviceDate = new Date(data.serviceDate);
      // const nextServiceDate = new Date(data.nextServiceDate);

      // if (nextServiceDate <= serviceDate) {
      //   setMessage("Next Service Date must be greater than Service Date");
      //   setIsError(true);
      //   setLoading(false);
      //   return;
      // }

      const serviceDate = new Date(data.serviceDate);

      if (data.nextServiceDate) {
        const nextServiceDate = new Date(data.nextServiceDate);
        if (nextServiceDate <= serviceDate) {
          setMessage("Next Service Date must be greater than Service Date");
          setMsgType("error");
          setLoading(false);
          return;
        }
      }

      let res;

      data.companyId = StorageService.activeCompany().companyId;

      if (isEdit) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await VehicleServiceService.update(data.id, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await VehicleServiceService.save(data);
      }

      if (res.status) {
        
        setMessage(isEdit ? "Updated Successfully" : "Saved Successfully");
        setMsgType("success");

        setTimeout(() => {
          navigate("/cpnl/vehicleservice/view");
        }, 1200);
      } else {
        throw new Error(res.message);
      }
    } catch (error) {
      console.error("Save failed:", error);

      if (error?.message?.includes("already exists")) {
        setMessage("Record already exists with this Vehicle Type and Vehicle");
      } else if (error?.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage("Failed to save Vehicle Service");
      }

     setMsgType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => navigate("/cpnl/vehicleservice/view");

  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify Vehicle Service" : "Add Vehicle Service"}
        secondTitle="Vehicle Management"
      />

      <div className="row">
        <div className="card p-4 bg-white shadow-sm">
          {/* ALERT MESSAGE */}
          {/* {message && (
            <div
              className="d-flex justify-content-between align-items-center w-100 mb-2 p-2"
              style={{
                borderRadius: "5px",
                backgroundColor: isError ? "#f8d7da" : "#d4edda",
                color: isError ? "#721c24" : "#155724",
              }}
            >
              <span>{message}</span>
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          


          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading VehicleService details...</div>
            </div>
          ) : (

            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row">
                {/* VEHICLE TYPE */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">Vehicle Type<span className="text-danger">*</span></label>
                  <select
                    className="form-control"
                    {...register("vehicleTypeId", {
                      required: "Vehicle Type is required",
                    })}
                    onChange={(e) => fetchVehicles(e.target.value)}
                  >
                    <option value="">Select Vehicle Type</option>
                    {vehicleTypes.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.vehicleType}
                      </option>
                    ))}
                  </select>
                  {errors.vehicleTypeId && (
                    <small className="text-danger">
                      {errors.vehicleTypeId.message}
                    </small>
                  )}
                </div>

                {/* VEHICLE */}
                <div className="mb-3 col-md-6">
                  <label className="form-label">Vehicle Name<span className="text-danger">*</span></label>
                  <select
                    className="form-control"
                    {...register("vehicleId", {
                      required: "Vehicle Name is required",
                    })}
                  >
                    <option value="">Select Vehicle</option>
                    {vehicles.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.vehicleName}-{v.registrationNo}
                      </option>
                    ))}
                  </select>
                  {errors.vehicleId && (
                    <small className="text-danger">
                      {errors.vehicleId.message}
                    </small>
                  )}
                </div>
              </div>

              {/* SERVICE DATES */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Service Date<span className="text-danger">*</span></label>
                  <input
                    type="date"
                    className="form-control"
                    {...register("serviceDate", {
                      required: "Service Date is required",
                    })}
                  />
                  {errors.serviceDate && (
                    <small className="text-danger">
                      {errors.serviceDate.message}
                    </small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">Next Service Date</label>
                  <input
                    type="date"
                    className="form-control"
                    // {...register("nextServiceDate", {
                    //   // required: "Next Service Date is required",
                    //   validate: (value) => {
                    //     const sd = getValues("serviceDate");
                    //     return new Date(value) > new Date(sd)
                    //       ? true
                    //       : "Next Service Date must be greater than Service Date";
                    //   },
                    // })}

                    {...register("nextServiceDate", {
                      validate: (value) => {
                        if (!value) return true; // allow empty
                        const sd = getValues("serviceDate");
                        return new Date(value) > new Date(sd)
                          ? true
                          : "Next Service Date must be greater than Service Date";
                      },
                    })}


                  />
                  {errors.nextServiceDate && (
                    <small className="text-danger">
                      {errors.nextServiceDate.message}
                    </small>
                  )}
                </div>
              </div>

              {/* KMS */}
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Service KMS/Hours</label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("serviceKMS", {
                      // required: "Service KMS is required",
                      min: { value: 1, message: "KMS must be > 0" },
                    })}
                  />
                  {errors.serviceKMS && (
                    <small className="text-danger">
                      {errors.serviceKMS.message}
                    </small>
                  )}
                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label">Next Service KMS/Hours<span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("nextServiceKMS", {
                      // required: "Next Service KMS is required",
                      validate: (value) => {
                        const current = Number(getValues("serviceKMS"));
                        return Number(value) > current
                          ? true
                          : "Next Service KMS must be greater than Service KMS";
                      },
                    })}
                  />
                  {errors.nextServiceKMS && (
                    <small className="text-danger">
                      {errors.nextServiceKMS.message}
                    </small>
                  )}
                </div>
              </div>

              {/* STATUS */}
              {/* <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">Status</label>
                  <select className="form-control" {...register("status")}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div> */}

              {/* BUTTONS */}
              <div>
                <button className="btn btn-primary me-2" disabled={loading}>
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? isEdit
                      ? "Updating..."
                      : "Saving..."
                    : isEdit
                      ? "Update"
                      : "Save"}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={loading}
                  onClick={handleCancel}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
